import React from "react";
import "./reelcraft.css";
import NewFooter from "../../components/NewFooter/NewFooter";
import { Carousel } from "../../components/VerticalCarousel";
import img6 from "../../assets/reelcraft/image (1).jpg";
import img7 from "../../assets/reelcraft/image (2).jpg";
import img8 from "../../assets/reelcraft/image (3).jpg";
import b1 from "../../assets/nsara/b1.png";
import b2 from "../../assets/nsara/b2.png";
import CardGrid from "../../components/productCardsGrid/productInfoCards";
import reelcraft101 from "../../assets/reelcraft101.png"
import reelcraft102 from "../../assets/reelcraft102.png"
import reelcraft103 from "../../assets/reelcraft103.png"
import reelcraft104 from "../../assets/reelcraft104.png"
import reelcraft105 from "../../assets/reelcraft105.png"
import reelcraft106 from "../../assets/reelcraft106.png"
import reelcraft107 from "../../assets/reelcraft107.png"
import reelcraft108 from "../../assets/reelcraft108.png"

export default function ReelCraft() {

const cards = [
  {
    title: "Intelligent Video Repurposing",
    description:
      "Automatically converts long-form and live video into vertical-first formats optimised for mobile and short-form platforms."
  },
  {
    title: "Content Intelligence & Metadata Enrichment",
    description:
      "Generates structured summaries, tags, themes, and descriptors that transform raw video into searchable content assets."
  },
  {
    title: "Chapterisation & Highlight Creation",
    description:
      "Identifies key moments to auto-create chapters, highlights, and clips from a single source video."
  },
  {
    title: "Visual Optimisation & Thumbnails",
    description:
      "Selects high-impact frames and applies intelligent cropping and branding to improve visual engagement."
  },
  {
    title: "Platform Optimisation",
    description:
      "Tailors content output for different platforms by adapting aspect ratios, formats, and presentation styles."
  },
  {
    title: "Audience Insights",
    description:
      "Extracts actionable insights from content signals to understand engagement patterns and viewer behaviour."
  },
  {
    title: "Performance Analytics",
    description:
      "Tracks content performance across formats and platforms to measure reach, effectiveness, and optimisation opportunities."
  },
  {
    title: "Multi-Language Localisation",
    description:
      "Expands global reach through automated transcription, translation, and language adaptation workflows."
  },
  {
    title: "Scalable Content Processing",
    description:
      "Designed to handle high-volume content pipelines efficiently, supporting both live streams and VOD workflows."
  }
];



  const whitepapers = [
    {
      id: 1,
      src: reelcraft101,
      alt: "image1 for carousel",
    },
    {
      id: 2,
      src: reelcraft102,
      alt: "image 2 for carousel",
    },
    {
      id: 3,
      src: reelcraft103,
      alt: "image 3 for carousel",
    },
        {
      id: 4,
      src: reelcraft104,
      alt: "image 4 for carousel",
    },
        {
      id: 5,
      src: reelcraft105,
      alt: "image 5 for carousel",
    },
      {
      id: 6,
      src: reelcraft106,
      alt: "image 6 for carousel",
    },   {
      id: 7,
      src: reelcraft107,
      alt: "image 7 for carousel",
    },
        {
      id: 8,
      src: reelcraft108,
      alt: "image 8 for carousel",
    },
  ];

  const blogs = [
    { id: '1', title: "End-to-End Automation at Scale", description: "ReelCraft supports enterprise-grade workflows, handling high-volume content processing while maintaining speed, consistency, and control.", name: '', image: b1 },
    { id: '2', title: "Platform-Ready, Performance-Driven Output", description: "Every asset is optimised for specific platforms, formats, and distribution channels, backed by insights that help refine content strategy and maximise ROI.", name: '', image: b2 },
  ];

  const BlogCard = ({ title, description, name, image }) => (
    <div className="sara-styled-card">
      <img className="overlay-image" src={image} alt={title} />
      <div className="card-content">
        <h5 className="title">{title}</h5>
        <p className="description">{description}</p>
        {/* <p className="author">Author: {name}</p> */}
      </div>
    </div>
  );

  return (
    <div style={{background: "black"}}>
      <div className="sara-container" >
        <div className="sara-first">
          <div className="logo">
            <img src={require("../../assets/products/reelcraft-removebg-preview.png")} alt="ReelCraft Logo" />
          </div>
          <div className="sara-title">
            <h3>ReelCraft</h3>
          </div>
          <div className="sara-des">
            <p>
              Reelcraft is an AI-driven video repurposing and content intelligence platform designed to help content owners, broadcasters, and digital publishers unlock maximum value from every piece of video content they create.

By combining intelligent verticalisation, automated enrichment, short-form creation, localisation, and workflow automation, ReelCraft transforms long-form and live video into discoverable, promotable, and monetisable assets optimised for today’s mobile-first and social-first viewing behaviour.
           </p>
          </div>
          <div className="img-section">
            {blogs.map((blog, index) => (
              <BlogCard key={index} {...blog} />
            ))}
          </div>
        </div>
        <div className="insight">
          <div className="sara1-carousel" >
            <Carousel data={whitepapers} />
            <div className="cus-des">
              <div className="cus-title">
                <h3>ReelCraft</h3>
<p>ReelCraft helps teams transform raw video into structured, ready-to-use content at scale.</p>
<p>It automates key steps like adaptation, enrichment, and optimisation across formats and platforms.</p>
<p>The platform reduces manual effort while improving speed, consistency, and output quality.</p>
<p>This enables organisations to maximise the value of every video asset they produce.</p>

                
              </div>
            </div>
          </div>
        </div>

        <div className="w-m-s-p">
          <div className="sara-title2">
            <h3>What makes ReelCraft Special</h3>
          </div>
          
      <CardGrid cards={cards}/>
          
        </div>
       
      </div>
       <NewFooter />
    </div>
  );
}
